module.exports = __webpack_public_path__ + "media/images/icon-svg/ideal-e639b01acdb2fbed1380877aa7215f76.svg";